// extracted by mini-css-extract-plugin
export default {"img":"LandingCard_img__uFZO8","title":"LandingCard_title__ji+ZR"};